import { DeleteRestoreIcon } from './DeleteRestoreIcon';

/**
 * author: Google
 * id 7837B9B7-2A6F-42E3-894D-C40D0080FB7B
 * name delete-restore
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-restore.svg
 * tags
 */
export const BinRestoreIcon = DeleteRestoreIcon;
export default BinRestoreIcon